<template>
<div v-if="this.$isMobile()">
  <!-- DA RIVEDERE --> 
  <!-- <v-parallax dark src="../assets/smartphoneFooter.jpg" id="contatti" style="height: 700px;">  -->
  <v-parallax dark src="../assets/smartphoneFooter.jpg" id="contatti"> 
  
    <div class="col-sm-12">
      <h4 class="font-weight-bold">{{seat.title}}</h4>
      <Label class="font-weight-light">{{seat.text}}</Label>
      
      <h4 class="font-weight-bold mt-4">{{contacts.title}}</h4>
      <Label class="font-weight-light">
        {{contacts.phoneText}}
        <a :href="'tel:+'+contacts.phoneHref">{{contacts.phoneHref}}</a>
      </Label>
      <Label class="font-weight-light">
        {{contacts.mailText}}
        <a :href="'mailto:'+contacts.mailHref">{{contacts.mailHref}}</a>
      </Label>
      
      <h4 class="font-weight-bold mt-4">{{openingHours.title}}</h4>
      <div class="d-flex flex-row">
        <Label class="font-weight-light mr-8">{{openingHours.days}}</Label>
        <Label class="font-weight-light">{{openingHours.hours}}</Label>
      </div>

      <!-- DA RIVEDERE -->
      <!-- <h4 class="font-weight-bold mt-8">{{estimate.title}}</h4>

      <form method="post">
        <Label class="font-weight-light">{{estimate.email}}</Label>
        <input class="form-control mb-2" id="email" type="email">
        <Label class="font-weight-light">{{estimate.message}}</Label>
        <textarea class="form-control mb-6" rows="5" id="message"></textarea>    
        <v-row justify="end">
          <v-btn class="mr-3" small color="smartphone-background-color" dark width="100px" @onclick="sendMail()">
            <span style="color: black !important;">{{estimate.textButton}}</span>
          </v-btn>
        </v-row>
      </form> -->

      <!-- DA RIVEDERE --> 
      <div class="d-flex" style="height: 200px;"></div>

    </div>
  </v-parallax>
</div>
<div v-else>
  <v-parallax dark src="../assets/footer.jpg" id="contatti">
    
    <div class="col-md-12 col-sm-12 row d-flex align-items-center ml-4">
      
      <div class="col-md-4 col-sm-6">

        <h1 class="display-1 font-weight-bold mt-8">{{seat.title}}</h1>
        <h4 class="font-weight-light mb-8">{{seat.text}}</h4>
        
        <h1 class="display-1 font-weight-bold mt-8">{{contacts.title}}</h1>
        <h4 class="font-weight-light">
          {{contacts.phoneText}}
          <a :href="'tel:+'+contacts.phoneHref">{{contacts.phoneHref}}</a>
        </h4>
        <h4 class="font-weight-light">
          {{contacts.mailText}}
          <a :href="'mailto:'+contacts.mailHref">{{contacts.mailHref}}</a>
        </h4>
         
        <h2 class="display-1 font-weight-bold mt-8">{{openingHours.title}}
        </h2>
        <div class="d-flex flex-row">
          <h4 class="font-weight-light mr-4">{{openingHours.days}}</h4>
          <h4 class="font-weight-light">{{openingHours.hours}}</h4>
        </div>

      </div>

      <!-- DA RIVEDERE -->
      <!-- <div class="d-flex flex-column col-md-4 col-sm-6">
        <h2 class="display-1 font-weight-bold">{{estimate.title}}</h2>
        
        <form method="post">
          <h4 class="font-weight-light">{{estimate.email}}</h4>
          <input class="form-control mb-2" id="email" type="email">
          <h4 class="font-weight-light">{{estimate.message}}</h4>
          <textarea class="form-control mb-6" rows="5" id="message"></textarea>    
          <v-row justify="end">
            <v-btn class="mr-3" small color="primary" dark width="100px" @onclick="sendMail()">
              <span>{{estimate.textButton}}</span>
            </v-btn>
          </v-row>
          <input type="button" value="Send Email" @onclick="sendEmail()"/> 
        </form>
        
      </div> -->

    </div>
  </v-parallax>
</div>
  
</template>

/* https://www.smtpjs.com/ */
<script src="https://smtpjs.com/v3/smtp.js"></script>
<script>
  export default {
    name: 'Contatti',
    data: () => ({
      seat: { 
        title: "Sede",
        text: " Viale Carancini, 9 – 62019 Recanati (MC)",
      },
      contacts: {
        title: "Contatti",
        phoneText: "Telefono:",
        phoneHref: "3357031889",
        mailText: "Email:",
        mailHref: "impresaedile.srl@hotmail.com",
      },
      openingHours: {
        title: "Orari d'apertura",
        days: "Lun-Ven",
        hours: "9:00 - 13:00 / 14:00 - 18:00",
      },
      estimate:{
        title: "Richiedi un preventivo",
        email: "Email:",
        message: "Messaggio:",
        textButton: "Invia"
      }
    }),
    created: function(){
      console.log("created");
      if(this.$isMobile()){
      } 
    },
    methods: {
      /* DA RIVEDERE */
      /* sendEmail() { 
        Email.send({ 
          Host: "smtp.gmail.com", 
          Username: "sender@email_address.com", 
          Password: "Enter your password", 
          To: 'Edoardo.Frapiccini@metisoft.it', 
          From: "edoardofrapiccini@alice.it", 
          Subject: "Preventivo", 
          Body: "hope", 
        }) 
        .then(function (message) { 
          alert("mail sent successfully") 
        }); 
      }  */
    }
  }
</script>


